import React from "react";
import BrandSection from "../BrandSection/BrandSection";
import "./Brands.css";

const Brands = () => {
  return (
    <div className="brands-page">
      <BrandSection />
    </div>
  );
};

export default Brands;

